import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ModalButtons from './ModalButtons';
import * as GlobalModalActions from '../../redux/actions/GlobalModalActions';

const Modal = (props) => {
  const { isOpen, title, children, centered, size, type, buttons, onClose, headerButtons, reverseButtons, className, backDrop, boxCenter } = props;
  const classes = classNames('custom-modal', 'fade', className, { show: isOpen });
  const contentClasses = classNames('custom-modal-content', { centered });
  const dialogClasses = classNames('custom-modal-dialog', `${size}`);
  const headerClasses = classNames(`header-${type}`);
  const titleClasses = classNames('title',`title-${type}`)
  return (
    <div className={classes} role="dialog">
      <div onClick={backDrop ? onClose : () => {}} className="modal-overlay" />
      <div className={contentClasses}>
        <div className={dialogClasses}>
          <header className={headerClasses}>
            <div><h3 className={titleClasses}>{title}</h3></div>
          </header>
          <div className="body">{children}</div>
          {headerButtons ? <ModalButtons buttons={buttons} onClose={onClose} reverse={reverseButtons} boxCenter={boxCenter} /> : ''}
          {!headerButtons ? (
            <footer>
              <ModalButtons buttons={buttons} onClose={onClose} reverse={reverseButtons} showInFooter boxCenter={boxCenter}/>
            </footer>
          ) : (
            ''
          )}
        </div>
      </div>
    </div>
  );
};

Modal.defaultProps = {
  centered: true,
  iconName: 'info-square',
  type: 'default',
  headerButtons: true,
  reverseButtons: false,
  backDrop: true,
};

Modal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func.isRequired,
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
      type: PropTypes.string,
      className: PropTypes.string,
      disabled: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
      action: PropTypes.func,
    })
  ),
  centered: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium', 'large', 'custom', 'small-confirm', 'auto']),
  iconName: PropTypes.string,
  type: PropTypes.oneOf(['default', 'warning', 'danger', 'info', 'success']),
  headerButtons: PropTypes.bool,
  reverseButtons: PropTypes.bool,
  backDrop: PropTypes.bool,
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...GlobalModalActions,
    },
    dispatch
  );

export default connect(null, mapDispatchToProps)(Modal);
